import { reduxKey } from './constants';
function getState(state) {
    return state[reduxKey] || {};
}
export function getReportPageState(state, deviationId) {
    return deviationId && getState(state)[deviationId] || {};
}
export function getIsInitialized(state, deviationId) {
    var _state_reduxKey_deviationId;
    return Boolean(deviationId) && state[reduxKey] !== undefined && ((_state_reduxKey_deviationId = state[reduxKey][deviationId]) === null || _state_reduxKey_deviationId === void 0 ? void 0 : _state_reduxKey_deviationId.data) !== undefined;
}
export function getIsLoading(state, deviationId) {
    return getReportPageState(state, deviationId).isLoading;
}

//# sourceMappingURL=selectors.js.map